<template>
    <div>
        <v-row class="ma-0 mb-2">
            <v-autocomplete 
                v-if="new_food_dish==''" class="mx-1" item-text="name" item-value="id" v-model="meal_plan_time.food_dish" outlined :dense="!show_detail" label="Platillo"
                :hide-no-data="!(searchFoodDishes!=''&&searchFoodDishes!=null&&searchFoodDishes!=undefined)" placeholder="Escribe para buscar" :loading="isLoadingFoodDishes" :search-input.sync="searchFoodDishes" :items="entries.food_dishes">
                <template v-slot:item="{item, attrs, on}">
                    <v-list-item v-on="on" v-bind="attrs" @click="addAlimentos(item.food)">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{item.name}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <span v-for="(food, index) in item.food" :key="index">{{food.name}}<span v-if="(index+1)<item.food.length">, </span></span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template> 
                <template slot="no-data">
                    <div class="px-4 py-1" @click="new_food_dish=searchFoodDishes">Crear platillo "{{searchFoodDishes}}"</div>
                </template> 
            </v-autocomplete>
            <v-text-field v-else class="mx-1" v-model="new_food_dish" outlined :dense="!show_detail" label="Platillo"></v-text-field>
            <v-btn :disabled="meal_plan_time.foods[0].food == ''" v-if="new_food_dish" text small class="py-7" @click="saveFoodDish()">Guardar</v-btn>
        </v-row>
        <v-row class="ma-0 px-2 pb-2" v-for="(food, index3) in meal_plan_time.foods" :key="index3">
            <v-col :cols="show_detail?'2':'4'" class="pa-0">
                <v-text-field class="mr-2 cantidades equivalentes" type="number" label="Cantidad" :dense="!show_detail" outlined v-model="food.quantity" suffix="equivalentes" persistent-hint 
                    :hint="food?.food?.other_measurements && food?.food?.other_measurements[0] ? 
                        ((food?.food?.other_measurements[0]?.serving * food?.quantity) + ' ' + food?.food?.other_measurements[0]?.unit_of_measurement)
                    :''"
                ></v-text-field>
            </v-col>
            <v-col :cols="show_detail?'5':'8'" class="pa-0">
                <v-autocomplete v-if="food.food==''||food.food==null" class="mr-2" :dense="!show_detail" outlined item-text="name" hide-no-data label="Alimento" placeholder="Escribe para buscar" :loading="isLoadingAlimentos" :search-input.sync="searchAlimentos" :items="entries.alimentos">
                    <template v-slot:item="data">
                        <v-list-item-content @click="food.food = data.item">
                            <v-list-item-title>{{data.item.name}}</v-list-item-title>
                            <v-list-item-subtitle style="font-size:10px;">{{data.item.food_group}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                </v-autocomplete>
                <v-row v-else class="ma-0" style="white-space: nowrap; border:1px grey solid; border-radius:3px; font-weight:500;" :style="show_detail?'padding:15px 10px;':'padding:7px 10px;'">
                    <span style="white-space: nowrap; width:80%;">{{food.food.name}}</span>
                    <v-spacer/>
                    <v-icon v-if="show_detail" @click="clearAutocomplete(), food.food=''" small style="white-space: nowrap;">mdi-pencil</v-icon>
                    <v-icon v-if="show_detail" @click="removeItem(index3)" small style="white-space: nowrap;" class="ml-3">mdi-trash-can-outline</v-icon>
                </v-row>
            </v-col>
            <v-col v-if="show_detail" cols="5" class="pa-0">
                <v-row style="font-size:13px; font-weight:600;" class="ma-0 px-5 py-4" v-if="food.food!=''">
                    <v-card dark color="grey" class="px-3 py-1">hc = {{(food.food?.carbohydrates * clacGrams(food)).toFixed(2)}}g</v-card>
                    <v-spacer/>
                    <v-card dark color="grey" class="px-3 py-1">ps = {{(food.food?.protein * clacGrams(food)).toFixed(2)}}g</v-card>
                    <v-spacer/>
                    <v-card dark color="grey" class="px-3 py-1">lp = {{(food.food?.lipids * clacGrams(food)).toFixed(2)}}g</v-card>
                    <v-spacer/>
                    <!-- kcal con 4/4/9 y fallback a energy*quantity -->
                    <v-card dark color="#e12826" class="px-3 py-1">
                      {{
                        (
                          (food.food?.carbohydrates || 0) * clacGrams(food) * 4 +
                          (food.food?.protein       || 0) * clacGrams(food) * 4 +
                          (food.food?.lipids        || 0) * clacGrams(food) * 9
                        ) || ((food.food?.energy || 0) * clacGrams(food))
                      .toFixed(2)}}cal
                    </v-card>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-spacer/>
            <v-icon :disabled="meal_plan_time.foods[meal_plan_time.foods.length-1].food==''" @click="addFood()">mdi-plus</v-icon>
            <v-spacer/>
        </v-row>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </div>
</template>

<script>
import axios from "axios"
export default {
    props:{
        meal_plan_time:Object,
        meal_plan_option: Object,
        index:Number,
        index2:Number,
        show_detail:Boolean
    },
    data(){
        return{
            snackbar: {
                show: false,
                message: null,
                color: null
            },
            new_food_dish:'',
            entries:{
                alimentos: [],
                food_dishes: []
            },
            isLoadingAlimentos: false,
            isLoadingFoodDishes: false,
            searchAlimentos: null,
            searchFoodDishes: null,
        }
    },
    watch: {
        new_food_dish:{
            handler(){
                if(this.new_food_dish!=''){
                    localStorage.setItem('isDirty', true)
                }
            }, deep:true
        },
        searchAlimentos(val){
            if (this.isLoadingAlimentos) return
            this.isLoadingAlimentos = true
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/food?filter[name]='+val+'&itemsPerPage=100')
            .then(res => {
                this.entries.alimentos = this.entries.alimentos.concat(res.data)
            }).finally(() => (this.isLoadingAlimentos = false))
        },
        searchFoodDishes(val){
            if (this.isLoadingFoodDishes) return
            this.isLoadingFoodDishes = true
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/food_dishes?filter[name]='+val)
            .then(res => {
                this.entries.food_dishes = res.data.data
            }).finally(() => (this.isLoadingFoodDishes = false))
        },
    },
    methods:{
        removeItem(index3){
            if(this.meal_plan_time.foods.length>1){
                this.meal_plan_time.foods.splice(index3, 1)
            }else{
                this.meal_plan_time.foods = [
                    {
                        food:undefined,
                        quantity: 0
                    }
                ]
            }
        },
        clacGrams(item){
            return item.quantity
        },
        saveFoodDish(){
            const new_food_dish = {
                name: this.new_food_dish,
                food_ids: this.meal_plan_time.foods.map(food=>food.food.id)
            }
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/food_dishes', new_food_dish).then(response=>{
                this.searchFoodDishes =  this.new_food_dish
                this.new_food_dish = ''
                this.snackbar = {
                    message: 'Platillo creado con éxito',
                    color: 'success',
                    show: true
                }
            }).catch(error => {
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
            })
        },
        clearAutocomplete(){
            const index = this.meal_plan_time.foods.indexOf(this.meal_plan_time.foods.filter(food=>food.food == '')[0])
            if(index>=0){
                this.meal_plan_time.foods.splice(index, 1)
            }
        },
        alimentoData(food_id){
            return this.entries.alimentos.filter(alimento=>alimento.id == food_id)[0]
        },
        addAlimentos(alimentos){
            this.entries.alimentos = alimentos
            this.$nextTick(() => {
                this.meal_plan_time.foods = alimentos.map(alimento=>{return{
                    food:alimento,
                    quantity:0
                }})
            })
        },
        addFood(){
            this.meal_plan_time.foods.push({
                food:'',
                quantity:''
            })
        },
    }
}
</script>

<style>
.equivalentes .v-text-field__details {
    display: block;
}
</style>
